import {FC, useEffect} from 'react'

type AccountRatesMissingModalProps = {
  onProceed: () => void
  onCancel: () => void
}

const OLIVE = '#6B7C2E'

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.45)',
    zIndex: 1055,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '520px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '24px 24px 0 24px',
  },
  iconWrap: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#FEE2E2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  title: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: '24px',
  },
  body: {
    padding: '16px 24px 24px 24px',
  },
  message: {
    margin: 0,
    fontSize: '14px',
    color: '#4B5563',
    lineHeight: '1.6',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '16px 24px 24px 24px',
    borderTop: '1px solid #F3F4F6',
  },
  cancelBtn: {
    flex: 1,
    maxWidth: '180px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 600,
    color: '#374151',
    backgroundColor: '#fff',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    cursor: 'pointer',
    lineHeight: 1,
  },
  proceedBtn: {
    flex: 1,
    maxWidth: '180px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: OLIVE,
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    lineHeight: 1,
  },
}

const AccountRatesMissingModal: FC<AccountRatesMissingModalProps> = ({onProceed, onCancel}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')

    const blockEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    document.addEventListener('keydown', blockEscape, true)

    return () => {
      document.body.classList.remove('modal-open')
      document.removeEventListener('keydown', blockEscape, true)
    }
  }, [])

  return (
    <div style={styles.overlay}>
      <div style={styles.modal} role='dialog' aria-modal='true'>
        <div style={styles.header}>
          <div style={styles.iconWrap}>
            <i
              className='bi bi-exclamation-triangle'
              style={{color: '#EF4444', fontSize: '18px'}}
            />
          </div>
          <p style={styles.title}>Account Rates Missing</p>
        </div>

        <div style={styles.body}>
          <p style={styles.message}>
            Client rates are not available for this configuration. Uploading rates are recommended
            prior to creating an appointment.
          </p>
        </div>

        <div style={styles.footer}>
          <button style={styles.cancelBtn} type='button' onClick={onCancel}>
            Cancel
          </button>
          <button style={styles.proceedBtn} type='button' onClick={onProceed}>
            Proceed Anyway
          </button>
        </div>
      </div>
    </div>
  )
}

export {AccountRatesMissingModal}
